import { useUi } from "@/state/ui";
import { useViewParams } from "./params";

export function TransferBasisToggle({ closePanel = true }: { closePanel?: boolean }) {
  const { bool, set } = useViewParams();
  const enabled = bool("inherit_transfers");
  return (
    <button
      type="button"
      className={`ctl ${enabled ? "on" : ""}`}
      aria-pressed={enabled}
      // the visible label drops "transfer cost" on phone; the accessible name
      // is the visible text, so speech control can say what it reads
      onClick={() => {
        if (closePanel) {
          useUi.getState().closeSidePanel();
          useUi.setState({ sidePanel: null });
        }
        set({ inherit_transfers: !enabled });
      }}
      title="Carry the sender's known cost forward through matched transfers. The recipient's actual purchase price may differ."
    >
      inherit <span className="narrow:hidden">transfer cost </span>basis
    </button>
  );
}
